import React from 'react'
import Bredcom from '../../Bradcom/CamaKingB'
import First from '../../Menrooms/Menroomdeatils/CamaKing';
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Habitación con Cama King</title>
        <meta
          name="description"
          content="Déjate envolver por el lujo y la comodidad en nuestra amplia habitación con cama king size, diseñada especialmente para brindar una experiencia de descanso inigualable. "
        />
      </Helmet>
        <main>
            <Bredcom title={"Habitación con Cama King"} subtitle={"Inicio"} newtitle={"Habitación con Cama King"} />
            <First/>
        </main>
    </>
  )
}

export default Main